export default function auth({ next, store, _next }) {
    // if(!store.getters.auth.loggedIn){
    if (!window.localStorage.getItem("rep")) {
        return _next({
            name: 'login'
        })
    }

    return next()
}